import store from '@state/store'

// auth related routes
const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next({ name: 'login' })
      },
    },
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'home',
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const integrationManagementRoutes = [
  {
    path: '/integracao/clientes',
    name: 'Painel de Integração',
    icon: 'grid',
    component: () =>
      lazyLoadView(import('@views/pages/integracao/clientes-vinculados')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

// apps
const integracaoRoutes = [
  {
    path: '/register',
    name: 'Relatórios',
    icon: 'cloud',
    landingPath: '/register/relatorios',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'relatorios',
        name: 'Central de Relatórios',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/relatorios-hub')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'integracoes-painel',
        name: 'Logs e Monitoramento',
        header: 'Integração',
        icon: 'activity',
        component: () => lazyLoadView(import('@views/pages/integracao/integracoes-painel')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-creasp',
        name: 'São Paulo - CREA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/sp')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-siga',
        name: 'Rio Grande do Sul - SIGA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/siga/downloadCSV')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-adab',
        name: 'Bahia - ADAB',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/ba')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-siagro',
        name: 'Paraná - SIAGRO',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/pr')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-ima',
        name: 'Minas Gerais - IMA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/mg')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-singen',
        name: 'Santa Catarina - SIGEN',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/sc')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-indea',
        name: 'Mato Grosso - INDEA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/mt')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-agrodefesa',
        name: 'Goiás - Agrodefesa',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/go')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-cfta',
        name: 'CFTA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/cfta')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-receitas-emitidas',
        name: 'Receitas Emitidas',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/receitas-emitidas')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const cadastrosRoutes = [
  {
    path: '/cadastros',
    name: 'Cadastros',
    icon: 'save',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'produtores',
        name: 'Produtor',
        icon: 'user',
        header: '',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/produtor_rural')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'responsavel-tecnico',
        name: 'Responsável Técnico',
        icon: 'users',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/agronomo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'produto',
        name: 'Produto',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/produto')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'produto-vinculo',
        name: 'Vinculação de Produtos',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/produto-vinculo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-produto',
        name: 'Tipo do Produto',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/tipo-produto')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'unidade',
        name: 'Unidade',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/unidade')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'categoria-conta',
        name: 'Categoria de Conta',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/categoria-conta')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-conta',
        name: 'Contas',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/tipo-conta')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'centro-custo',
        name: 'Centro de Custo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/centro-custo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const documentacaoRoutes = [
  {
    path: '/docs',
    name: 'Treinamentos',
    icon: 'book',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'videos',
        name: 'Vídeos',
        header: 'API',
        icon: 'share-2',
        component: () => lazyLoadView(import('@views/pages/docs/videos')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'suporte',
        name: 'Suporte',
        header: 'Suporte',
        icon: 'share-2',
        component: () => lazyLoadView(import('@views/pages/docs/suporte')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'documentacao',
      //   name: 'API',
      //   header: 'API',
      //   icon: 'share-2',
      //   component: () => lazyLoadView(import('@views/pages/docs/documentacao')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
    ],
  },
]

const receituarioRoutes = [
  {
    path: '/register',
    name: 'Receituário',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'receita',
        name: 'Emitir Receituário',
        header: 'Menu',
        icon: 'clipboard',
        component: () => lazyLoadView(import('@views/pages/register/receita')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },      
      {
        path: 'receita-complementar',
        name: 'Emitir Receituário Complementar',
        header: 'Menu',
        icon: 'clipboard',
        component: () =>
          lazyLoadView(import('@views/pages/register/receita-complementar')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'gestao-receituarios',
      //   name: 'Gestão de Receituários',
      //   header: 'Menu',
      //   icon: 'layers',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/gestao-receituarios')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'logs-sisdev',
      //   name: 'Logs SISDEV',
      //   header: 'Menu',
      //   icon: 'activity',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/logs-sisdev')),
      //   meta: {
      //     authRequired: true,
      //     beforeResolve(routeTo, routeFrom, next) {
      //       const user = store.state.auth.currentUser
      //         ? store.state.auth.currentUser.user
      //         : ''

      //       if (user === 'agrotresestrelas' || user === 'admin_sistema') {
      //         next()
      //         return
      //       }

      //       next({ path: '/register/receita' })
      //     },
      //   },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'gerar-receita-xml',
      //   name: 'Receituário por XML',
      //   header: 'Menu',
      //   icon: 'clipboard',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/gerar-receita-xml')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'gerar-receita-excel',
        name: 'Gerar Receita por Excel',
        header: 'Menu',
        icon: 'file-text',
        component: () =>
          lazyLoadView(import('@views/pages/register/gerar-receita-excel')),
        meta: {
          authRequired: true,
          allowedUsers: ['admin_sistema', 'admin_sistemas', 'monsanto'],
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'ficha-emergencia',
        name: 'Ficha de Emergência',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ficha-emergencia')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'consulta-fitossanitaria',
        name: 'Consulta Fitossanitária',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/fitossanitaria')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      
      // {
      //   path: 'cliente',
      //   name: 'Cliente',
      //   icon: 'cloud',
      //   component: () => lazyLoadView(import('@views/pages/cadastros/cliente')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
    ],
  },
]

const receituarioSyngentaRoutes = [
  {
    path: '/register',
    name: 'Syngenta',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      // {
      //   path: 'produtores',
      //   name: 'Produtor',
      //   icon: 'user',
      //   header: '',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/produtor_rural')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'responsavel-tecnico',
        name: 'Responsável Técnico',
        icon: 'users',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/agronomo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receita',
        name: 'Receita',
        header: 'Menu',
        icon: 'clipboard',
        component: () => lazyLoadView(import('@views/pages/register/receita')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receita-complementar',
        name: 'Receita Complementar',
        header: 'Menu',
        icon: 'clipboard',
        component: () =>
          lazyLoadView(import('@views/pages/register/receita-complementar')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'logs-sisdev',
      //   name: 'Logs SISDEV',
      //   header: 'Menu',
      //   icon: 'activity',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/logs-sisdev')),
      //   meta: {
      //     authRequired: true,
      //     beforeResolve(routeTo, routeFrom, next) {
      //       const user = store.state.auth.currentUser
      //         ? store.state.auth.currentUser.user
      //         : ''

      //       if (user === 'agrotresestrelas' || user === 'admin_sistema') {
      //         next()
      //         return
      //       }

      //       next({ path: '/register/receita' })
      //     },
      //   },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'gerar-receita-xml',
      //   name: 'Receituário por XML',
      //   header: 'Menu',
      //   icon: 'clipboard',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/gerar-receita-xml')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'ficha-emergencia',
        name: 'Ficha de Emergência',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ficha-emergencia')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'produto-vinculo',
        name: 'Vinculação de Produtos',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/produto-vinculo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const fichaEmergenciaRoutes = [
  {
    path: '/query',
    name: 'Ficha Emergência',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'ficha-emergencia',
        name: 'Ficha de Emergência',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ficha-emergencia')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const gerencialRoutes = [
  {
    path: '/register',
    name: 'Gerencial',
    icon: 'save',
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'produtos',
        name: 'Produto',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/produto')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'empresa-sistema',
        name: 'Empresas Sistema',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/empresa-sistema')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'vincular-plano',
        name: 'Vincular Plano',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/vincular-plano')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'itens-produtos',
        name: 'Relações',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/item-produto')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'restricoes-estado',
        name: 'Restrições Estado',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/restricoes-estado')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'pragas',
        name: 'Praga',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/praga')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'empresa-defensivo',
        name: 'Empresas Defensivos',
        icon: 'home',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/empresa-defensivo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'classes-toxicologicas',
        name: 'Classe Toxicológica',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/classe-toxicologica')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'culturas',
        name: 'Cultura',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/cultura')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'unidades',
        name: 'Unidade',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/unidade')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'classe-produto',
        name: 'Classe do Produto',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/tipo-produto')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-formulacao',
        name: 'Tipo Formulação',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/tipo-formulacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-aplicacao',
        name: 'Tipo Aplicação',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/tipo-aplicacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'locais-aplicacao',
        name: 'Local Aplicação',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/local-aplicacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'grupos-alvos',
        name: 'Grupo Alvo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/grupo-alvo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'epocas-alvos',
        name: 'Época Alvo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/epoca-alvo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'estados',
        header: 'Cadastros',
        name: 'Estados',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/estado')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'conta-bancaria',
        header: 'Cadastros',
        name: 'Conta Bancária',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/conta-bancaria')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'categoria-conta',
        header: 'Cadastros',
        name: 'Categorias/Fluxo de Caixa',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/categoria-conta')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'centro-custo',
        header: 'Cadastros',
        name: 'Centro de Custo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/centro-custo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'ingrediente-ativo',
        header: 'Cadastros',
        name: 'Ingrediente Ativo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ingrediente-ativo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'grupo-quimico',
        header: 'Cadastros',
        name: 'Grupo químico',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/grupo-quimico')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'meio-ambiente',
        header: 'Cadastros',
        name: 'Meio ambiente',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/meio-ambiente')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const financeiroRoutes = [
  {
    path: '/financeiro',
    name: 'Financeiro',
    icon: 'dollar-sign',
    redirect: '/financeiro/dashboard',
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [      
      {
        path: 'contas-a-receber',
        name: 'Receber',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/contas-a-receber')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'contas-a-pagar',
        name: 'Pagar',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/contas-a-pagar')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },      
      {
        path: 'fluxo-de-caixa',
        name: 'Fluxo de Caixa',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/fluxo-de-caixa')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'conciliacao-bancaria',
        name: 'Conciliação Bancária',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/conciliacao-bancaria')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'recibo',
      //   name: 'Recibo',
      //   icon: 'box',
      //   // header: 'Cadastros',
      //   meta: { authRequired: true },
      //   component: () =>
      //   lazyLoadView(import('@views/pages/finances/recibo')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
    ],
  },
]

// apps
const fiscalRoutes = [
  {
    path: '/estoque',
    name: 'Estoque',
    icon: 'file-text',
    redirect: '/estoque/dashboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      // {
      //   path: 'dashboard',
      //   name: 'Dashboard Estoque',
      //   icon: 'grid',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/estoque/dashboard')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'sugestao-reposicao',
      //   name: 'Sugestao de Reposicao',
      //   icon: 'shopping-bag',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/estoque/sugestao-reposicao')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'lotes',
        name: 'Lotes',
        icon: 'box',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/estoque/lotes')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'entrada-nf',
      //   name: 'Entrada de Nota Fiscal',
      //   header: 'Integração',
      //   icon: 'cloud',
      //   component: () => lazyLoadView(import('@views/pages/fiscal/entrada-nf')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'movimentacao',
        name: 'Movimentações',
        icon: 'box',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/estoque/movimentacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'ajuste-estoque',
      //   name: 'Ajuste de Estoque',
      //   icon: 'sliders',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/estoque/ajuste-estoque')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
    ],
  },
]

const tributarioRoutes = [
  {
    path: '/tributario',
    name: 'Tributário',
    icon: 'percent',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'upload',
        name: 'Upload de arquivos',
        icon: 'box',
        component: () => lazyLoadView(import('@views/pages/upload/upload')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'processamento',
        name: 'Processamento de arquivos',
        icon: 'box',
        component: () =>
          lazyLoadView(import('@views/pages/upload/processamentos')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const configRoutes = [
  {
    path: '/configuracao',
    name: 'Configurações',
    icon: 'settings',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'empresa',
        name: 'Empresa',
        icon: 'box',
        component: () => lazyLoadView(import('@views/pages/config/empresa')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'config',
        name: 'Configuração',
        icon: 'box',
        component: () =>
          lazyLoadView(import('@views/pages/config/configuracao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'webhook',
        name: 'WebHook',
        icon: 'box',
        component: () => lazyLoadView(import('@views/pages/config/webhook')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const authProtectedRoutes = [
  ...dashboardRoutes,
  ...integrationManagementRoutes,
  ...cadastrosRoutes,
  ...receituarioRoutes,
  ...receituarioSyngentaRoutes,
  ...fiscalRoutes,
  ...financeiroRoutes,
  ...integracaoRoutes,
  ...gerencialRoutes,
  ...configRoutes,
  ...documentacaoRoutes,
]

const allRoutes = [...authRoutes, ...authProtectedRoutes]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
